import { CURRENT_ROLE } from "./API/url";

export const TrendingSortFilters = [
  {
    id: 1,
    value: "1",
    valueOrig: "questionAnswered",
    label: "Latest Answered",
    sortOrder: "desc",
  },
  {
    id: 2,
    value: "2",
    valueOrig: "questionAnswered",
    label: "Oldest Answered",
    sortOrder: "asc",
  },
  {
    id: 3,
    value: "3",
    valueOrig: "questionAsked",
    label: "Latest Asked",
    sortOrder: "desc",
  },
  {
    id: 4,
    value: "4",
    valueOrig: "questionAsked",
    label: "Latest asked",
    sortOrder: "asc",
  },
  {
    id: 5,
    value: "5",
    valueOrig: "mostViewed",
    label: "Most Viewed",
    sortOrder: "desc",
  },
];
export const expertAnsweredSortFilters = [
  // {
  //   id: 1,
  //   value: "1",
  //   label: "Date Asked ",
  //   origValue: "questionPostedTimeStamp",
  // },
  // {
  //   id: 2,
  //   value: "2",
  //   label: "Date Answered",
  //   origValue: "questionAnswered",
  // },
  {
    id: 1,
    value: "1",
    label: "Last Updated",
    origValue: "lastUpdated",
  },

  {
    id: 2,
    value: "2",
    label: "Viewed",
    origValue: "viewed",
  },
  {
    id: 3,
    value: "3",
    label: "Ratings",
    origValue: "rating",
  },
  // {
  //   id: 4,
  //   value: "4",
  //   label: "Transferred QA",
  //   origValue: "transferdate",
  // },
];

export const answeredSortFilters = [
  {
    id: 1,
    value: "1",
    origValue: "questionasked",
    label: "Asked (Latest)",
    sortOrder: "desc",
  },
  {
    id: 2,
    value: "2",
    origValue: "questionasked",
    label: "Asked (Oldest)",
    sortOrder: "asc",
  },
  {
    id: 10,
    value: "10",
    origValue: "answered",
    label: "Answered (Latest)",
    sortOrder: "desc",
  },
  {
    id: 11,
    value: "11",
    origValue: "answered",
    label: "Answered (Oldest)",
    sortOrder: "asc",
  },
  {
    id: 12,
    value: "12",
    origValue: "lastupdated",
    label: "Last Update (Latest)",
    sortOrder: "desc",
  },
  {
    id: 13,
    value: "13",
    origValue: "lastupdated",
    label: "Last Update (Oldest)",
    sortOrder: "asc",
  },
  {
    id: 3,
    value: "3",
    origValue: "ratingtimestamp",
    label: "Rated (Latest)",
    sortOrder: "desc",
  },
  {
    id: 4,
    value: "4",
    origValue: "ratingtimestamp",
    label: "Rated (Oldest)",
    sortOrder: "asc",
  },
  {
    id: 5,
    value: "5",
    origValue: "rating",
    label: "Rated (Best)",
    sortOrder: "desc",
  },
  {
    id: 6,
    value: "6",
    origValue: "rating",
    label: "Rated (Worst)",
    sortOrder: "asc",
  },
  {
    id: 7,
    value: "7",
    origValue: "unrated",
    label: "UnRated",
    sortOrder: "",
  },
  {
    id: 8,
    value: "8",
    origValue: "likes",
    label: "Likes",
    sortOrder: "",
  },
  
];
export const answeredSortOptions =
  CURRENT_ROLE === "Seeker" ? answeredSortFilters : expertAnsweredSortFilters;

export const favouriteSortFilters = [
  {
    id: "1",
    value: "recently asked",
    label: "Latest Asked",
    origValue: "questionAsked",
    sortOrder: "desc",
  },
  {
    id: "2",
    value: "oldest asked",
    label: "Oldest Asked",
    origValue: "questionAsked",
    sortOrder: "asc",
  },
];

export const seekerSideBarOptions = [
  {
    id: 0,
    value: "home",
    label: "Home",
    route: "/seekerHome/",
    ispartition: true,
  },
  {
    id: 1,
    value: "trending1",
    label: "Trending",
    route: "/seekerHome/trending/",
    ispartition: false,
  },
  {
    id: 2,
    value: "trending2",
    label: "Key Terms",
    route: "/seekerHome/keyterm/",
    ispartition: true,
  },
  {
    id: 3,
    value: "mysearches1",
    label: "Open",
    route: "/seekerHome/open/",
    ispartition: false,
  },
  {
    id: 4,
    value: "mysearches2",
    label: "Answered",
    route: "/seekerHome/answered/",
    ispartition: false,
  },
  {
    id: 9,
    value: "mydownloads",
    label: "My Downloads",
    route: "/seekerHome/downloads/",
    ispartition: true,
  },
  {
    id: 5,
    value: "mysearches3",
    label: "History",
    route: "/seekerHome/history/",
    ispartition: true,
  },
  {
    id: 9,
    value: "awards",
    label: "Awards",
    route: "",
    ispartition: true,
  },
  {
    id: 6,
    value: "favourite",
    label: "Favorite",
    route: "/seekerHome/favourite",
    ispartition: false,
  },
  {
    id: 7,
    value: "sharedby",
    label: "Shared by Me",
    route: "/seekerHome/sharedby",
    ispartition: false,
  },
  {
    id: 8,
    value: "sharedwith",
    label: "Shared with Me",
    route: "/seekerHome/sharedwith",
    ispartition: true,
  },
  // {
  //   id: 9,
  //   value: "atomizer",
  //   label: "Atomizer",
  //   route: "/seekerHome/atomizer",
  //   ispartition: true,
  // },
];
export const selectTypes = [
  { key: 0, value: "PDF" },
  { key: 1, value: "Image" },
  { key: 2, value: "Video" },
  { key: 3, value: "Scrape URL" },
  { key: 4, value: "PDF URL Link" },
  { key: 5, value: "Q&A List (CSV)" },
  { key: 6, value: "List of PDF URL Links (CSV)" },
  { key: 7, value: "Multiple Files" },
  { key: 8, value: "List of Bloomfire Links (CSV)" },
  { key: 9, value: "Bloomfire Category" },
  { key: 10, value: "PDF Native" },
  // { key: 10, value: "" },
];

export const urlDepthConstant = [
  { key: 0, value: "0" },
  { key: 1, value: "1" },
  { key: 2, value: "2" },
  { key: 3, value: "3" },
  { key: 4, value: "4" },
  { key: 5, value: "5" },
];

export const Frequency = [
  { key: 1, value: "Once" },
  { key: 2, value: "Monthly" },
];

export const Categories = [
  { value: "QGenda Update", label: "QGenda Update" },
  { value: "Tools for CS", label: "Tools for CS" },
  { value: "Settings Tab", label: "Settings Tab" },
  { value: "Credit Allocation", label: "Credit Allocation" },
  { value: "Labels", label: "Labels" },
  { value: "Daily Sums", label: "Daily Sums" },
  { value: "Locations", label: "Locations" },
  { value: "Series", label: "Series" },
  { value: "Work Patterns", label: "Work Patterns" },
  { value: "Targets", label: "Targets" },
  { value: "Admin Tab", label: "Admin Tab" },
  { value: "Stats Tab", label: "Stats Tab" },
  { value: "Landing Pages / Links", label: "Landing Pages / Links" },
  { value: "Request", label: "Request" },
  { value: "Change Log", label: "Change Log" },
  { value: "Swap", label: "Swap" },
  { value: "Available Shifts", label: "Available Shifts" },
  { value: "Reports and Notification", label: "Reports and Notification" },
  { value: "QGenda On-Call", label: "QGenda On-Call" },
  { value: "Insights", label: "Insights" },
  { value: "Capacity Management", label: "Capacity Management" },
  { value: "Capacity / Daily", label: "Capacity / Daily" },
  { value: "TTCM", label: "TTCM" },
  { value: "Calendar Syncs", label: "Calendar Syncs" },
  { value: "Support Troubleshooting", label: "Support Troubleshooting" },
  { value: "New Hire", label: "New Hire" },
  { value: "Misc / Other", label: "Misc / Other" },
  {
    value: "Schedule / Automation Configuration",
    label: "Schedule / Automation Configuration",
  },
  { value: "Feature", label: "Feature" },
  { value: "Product", label: "Product" },
  { value: "Integration", label: "Integration" },
  { value: "Process", label: "Process" },
  { value: "Support", label: "Support" },
];

export const expertSideBarOptions = [
  {
    id: 0,
    value: "home",
    label: "Home",
    route: "/expertHome/open",
    ispartition: true,
  },
  {
    id: 1,
    value: "trending1",
    label: "Trending",
    route: "/expertHome/trending/",
    ispartition: false,
  },
  {
    id: 2,
    value: "trending2",
    label: "Key Terms",
    route: "/expertHome/keyterm/",
    ispartition: true,
  },
  {
    id: 4,
    value: "mysearches2",
    label: "Answered",
    route: "/expertHome/answered/",
    ispartition: false,
  },
  {
    id: 9,
    value: "stat",
    label: "My Stats",
    route: "/expertHome/favourite",
    ispartition: true,
  },
  {
    id: 6,
    value: "favourite",
    label: "Favorite",
    route: "/expertHome/favourite",
    ispartition: false,
  },
  {
    id: 7,
    value: "sharedby",
    label: "Shared by Me",
    route: "/expertHome/sharedby",
    ispartition: false,
  },
  {
    id: 8,
    value: "sharedwith",
    label: "Shared with Me",
    route: "/expertHome/sharedwith",
    ispartition: true,
  },
];

// export const cmSideBarOptions = [
//   {
//     id: 0,
//     value: "cmhome",
//     label: "Overview",
//     route: "/cmHome/",
//     ispartition: true,
//   },
//   // {
//   //   id: 1,
//   //   value: "cmnotification",
//   //   label: "Notification",
//   //   route: "/cmHome/notification/",
//   //   ispartition:true,
//   //   redirect:'notification'
//   // },
//   {
//     id: 2,
//     value: "cmemails",
//     label: "Email Threads",
//     route: "/cmHome/emailThreads/",
//     ispartition: true,
//     redirect: "emailthread",
//   },
//   {
//     id: 4,
//     value: "cmexpertrecords",
//     label: "Expert Records",
//     route: "/cmHome/expertRecords/",
//     ispartition: true,
//   },
//   {
//     id: 9,
//     value: "cmsuggestion",
//     label: "Search Suggestions",
//     route: "/cmHome/suggestions",
//     ispartition: true,
//   },
//   {
//     id: 6,
//     value: "cmatomizer",
//     label: "Atomizer",
//     route: "/cmHome/atomizer",
//     ispartition: true,
//   },
//   {
//     id: 7,
//     value: "cmingestedknowledge",
//     label: "Ingested Knowledge",
//     route: "/cmHome/ingestedKnowledge",
//     ispartition: true,
//   },
//   {
//     id: 8,
//     value: "cmsharedfolder",
//     label: "Shared Folders",
//     route: "/cmHome/sharedfolders",
//     ispartition: true,
//   },
//   {
//     id: 10,
//     value: "cmprofile",
//     label: "My Profile",
//     route: "/cmHome/profile",
//     ispartition: true,
//   },
// ];

export const cmSideBarOptions = [
  {
    id: 0,
    value: "cmhome",
    label: "Insights Dashboard",
    route: "/cmHome/",
    ispartition: true,
  },
    {
    id: 9,
    value: "cmsuggestion",
    label: "Search History",
    // route: "/cmHome/suggestions",
    route:'/cmHome/searchHistory',
    ispartition: true,
  },
    {
    id: 4,
    value: "cmexpertrecords",
    label: "Expert Responses",
    route: "/cmHome/expertResponses/",
    ispartition: true,
  },
    {
    id: 7,
    value: "cmingestedknowledge",
    label: "Knowledge Ingested",
    route: "/cmHome/knowledgeIngested",
    ispartition: true,
  },
    {
    id: 6,
    value: "cmatomizer",
    label: "Knowledge Atomizer",
    route: "/cmHome/knowledgeAtomizer",
    ispartition: true,
  },
  {
    id: 8,
    value: "cmsharedfolder",
    label: "Shared Folders",
    route: "/cmHome/sharedfolders",
    ispartition: true,
  },
    {
    id: 2,
    value: "cmemails",
    label: "Email Threads",
    route: "/cmHome/emailThreads/",
    ispartition: true,
    redirect: "emailthread",
  },
    {
    id: 10,
    value: "cmprofile",
    label: "My Profile",
    route: "/cmHome/profile",
    ispartition: true,
  },
]
export const adminSideBarOptions = [
  {
    id: 2,
    value: "manageuser",
    label: "Manage Users",
    route: "/adminhome/",
    ispartition: true,
    // redirect:'emailthread'
  },
  {
    id: 4,
    value: "managerole",
    label: "Manage Roles",
    route: "/adminhome/managerole/",
    // ispartition:true
  },
  {
    id: 9,
    value: "managepermision",
    label: "Manage Permissions",
    route: "/adminhome/permission",
    ispartition: true,
  },
  {
    id: 6,
    value: "restrictPermission",
    label: "Restrict Permissions",
    route: "/adminhome/restrictPermission",
    ispartition: true,
  },
  {
    id: 0,
    value: "setting",
    label: "Settings",
    route: "/adminhome/settings",
    ispartition: true,
  },
  {
    id: 7,
    value: "cmprofile",
    label: "My Profile",
    route: "/adminhome/profile",
    ispartition: true,
  },
];
export const sideBarOptions =
  CURRENT_ROLE === "Seeker"
    ? seekerSideBarOptions
    : CURRENT_ROLE === "Expert"
    ? expertSideBarOptions
    : CURRENT_ROLE === "CM"
    ? cmSideBarOptions
    : adminSideBarOptions;

export const CurationFilters = [
  {
    id: "1",
    value: "1",
    label: "High",
    description: "curation",
  },
  {
    id: "2",
    value: "2",
    label: "Medium",
    description: "curation",
  },
  {
    id: "3",
    value: "3",
    label: "Low",
    description: "curation",
  },
];
export const questionTypeCM = [
  "Question",
  "Exclude Question",
  "Response",
  "Exclude Response",
];
export const questionTypeCM2 = [
  "Technical Issues",
  "Individual User Issues",
  "System Features",
  "Process and Guidance",
  "Misc Issues"
];
export const curationStatus = ["High", "Medium", "Low"];
export const headerFontSize = [24, 22, 20, 18, 16, 14];
export const questionTypeCMObj = [{Name:'Question',label:'Question',value:'0'}, {Name:"Exclude Question",label:'Exclude Question',value:'1'},{Name:'Response',label:'Response',value:'2'},{Name:'Exclude Response',label:'Exclude Response',value:'3'}]
export const questionTypeCMObj2 = [{Name:'Technical Issues',label:'Technical Issues',value:'0'}, {Name:"Individual User Issues",label:'Individual User Issues',value:'1'},{Name:'System Features',label:'System Features',value:'2'},{Name:'Process and Guidance',label:'Process and Guidance',value:'3'},{Name:'Misc Issues',label:'Misc Issues',value:'4'}]
export const ingestTypeObj = [{Name:'Pdf',label:'Pdf',value:'Pdf'}, {Name:"Image",label:'Image',value:'Image'},{Name:'Video',label:'Video',value:'Video'},{Name:'Thread',label:'Thread',value:'Thread'},{Name:'Url Crawl',label:'Url Crawl',value:'urlcrawl'},{Name:'Email',label:'Email',value:'emailIntegration'}]

export const DaysArr = [
  { label: "Monday", value: "MONDAY", name: "Monday" },
  { label: "Tuesday", value: "TUESDAY", name: "Tuesday" },
  { label: "Wednesday", value: "WEDNESDAY", name: "Wednesday" },
  { label: "Thursday", value: "THURSDAY", name: "Thursday" },
  { label: "Friday", value: "FRIDAY", name: "Friday" },
  { label: "Saturday", value: "SATURDAY", name: "Saturday" },
  { label: "Sunday", value: "SUNDAY", name: "Sunday" },
];

export const hoursArr = [
  { label: "0 H", value: "0", name: "0" },
  { label: "1 H", value: "1", name: "1" },
  { label: "2 H", value: "2", name: "2" },
  { label: "3 H", value: "3", name: "3" },
  { label: "4 H", value: "4", name: "4" },
  { label: "5 H", value: "5", name: "5" },
  { label: "6 H", value: "6", name: "6" },
  { label: "7 H", value: "7", name: "7" },
  { label: "8 H", value: "8", name: "8" },
  { label: "9 H", value: "9", name: "9" },
  { label: "10 H", value: "10", name: "10" },
  { label: "11 H", value: "11", name: "11" },
  { label: "12 H", value: "12", name: "12" },
  { label: "13 H", value: "13", name: "13" },
  { label: "14 H", value: "14", name: "14" },
  { label: "15 H", value: "15", name: "15" },
  { label: "16 H", value: "16", name: "16" },
  { label: "17 H", value: "17", name: "17" },
  { label: "18 H", value: "18", name: "18" },
  { label: "19 H", value: "19", name: "19" },
  { label: "20 H", value: "20", name: "20" },
  { label: "21 H", value: "21", name: "21" },
  { label: "22 H", value: "22", name: "22" },
  { label: "23 H", value: "23", name: "23" },
  { label: "24 H", value: "24", name: "24" },
];

export const settingListAdmin = {
  Routing: [
    {
      text: "Re-routing Interval",
      subText:
        "Maximum amount of time for an Expert to answer a question before it gets routed to a different Expert",
    },
    {
      text: "Abort Period",
      subText:
        "Maximum amount of time the Seeker should be waiting for an answer before sending it to the Conversation Manager",
    },
    {
      text: "Experts Assigned",
      subText:
        "Maximum Experts should be assigned to the question everytime the routing kicks in",
    },
    {
      text: "Max Acceptance SLA",
      subText:
        "Maximum SLA time that an Expert can choose while accepting a question",
    },
    {
      text: "Minimum Answers",
      subText:
        "Minimum answers every question should have from Experts, i.e. question will keep routing until it gets this many answers",
    },
    {
      text: "Curation Routing Method",
      subText:
        "Based on the selected method, the Question keeps routing until the answer gets curated",
    },
  ],
  "Search Results": [
    {
      text: "User Ranking",
      subText: "Enable/Disable User Ranking",
    },
    {
      text: "Text Summarization",
      subText: "Enable/Disable Text summarization",
    },
    {
      text: "Search Count Email Records",
      subText: "Maximum amount of Email records shown",
    },
    {
      text: "Search Count Doc Records",
      subText: "Maximum amount of Doc records shown",
    },
    {
      text: "Search Count Expert Records",
      subText: "Maximum amount of Expert records shown",
    },
    {
      text: "Auto Suggest Count Expert Records",
      subText: "Maximum amount of auto suggest records shown",
    },
  ],
  "Expert Settings": [
    {
      text: "Urgent Question Timeout Period",
      subText: "Timeout period to add new experts in queue",
    },
    {
      text: "Unanswered Question Timeout Period",
      subText: "Default time frame for unanswered questions to be shown",
    },
    {
      text: "Declined Answer Window",
      subText:
        "Maximum amount of time in which the Seeker's declined questions are listed",
    },
  ],
  "Knowledge Curation": [
    {
      text: "Expert Curation Evergreen Window",
      subText:
        "Default time frame dedicated to the Mark Evergreen function in Expert Curation View",
    },
    {
      text: "Expert Answer Expiration",
      subText:
        "Maximum amount of time in which the Expert's answer is not expired",
    },
    {
      text: "Seeker Curation Visiblity",
      subText: "Enable/Disable Seeker Curation Visiblity",
    },
  ],
  "Seeker Home Page Settings": {
    "User Level": [
      {
        text: "User Searches",
        subText: "Total queries searched by users",
      },
      {
        text: "User Knowledge Records Viewed",
        subText: "Total knowledge records viewed by users",
      },
      {
        text: "User Question Submitted",
        subText: "Total questions asked by single user",
      },
      {
        text: "User Knowledge Records Viewed MinCount",
        subText: "Knowledge Records Viewed MinCount",
      },
      {
        text: "User Overall Searches MinCount",
        subText: "User Overall Searches MinCount",
      },
      {
        text: "User Questions Submitted To Experts MinCount",
        subText: "Total knowledge records viewed by single user",
      },
    ],
    "Total Users": [
      {
        text: "Overall Searches",
        subText: "Total queries searched by users",
      },
      {
        text: "Overall Knowledge Records Viewed",
        subText: "Total knowledge records viewed by users",
      },
      {
        text: "Overall Questions Answered",
        subText: "Total questions answered by users",
      },
      {
        text: "Overall LoggedIn",
        subText: "Total users logged In",
      },
      {
        text: "Overall Document Scraped",
        subText: "Total document scraped",
      },
      {
        text: "Overall Likes",
        subText: "Total questions liked by users",
      },
      {
        text: "Overall Key Terms",
        subText: "Total viewed Keyterm",
      },
      {
        text: "Overall Question View",
        subText: "Total Question View by users",
      },
      {
        text: "Overall Knowledge Updates",
        subText: "Total Knowledge Updates",
      },
    ],
    "System Level": [
      {
        text: "System Knowledge Records Viewed MinCount",
        subText: "Knowledge Records Viewed MinCount",
      },
      {
        text: "System Knowledge Updates MinCount",
        subText: "System Knowledge Updates MinCount",
      },
      {
        text: "System Likes MinCount",
        subText: "System Likes MinCount",
      },
      {
        text: "System Overall Searches MinCount",
        subText: "System Overall Searches",
      },
      {
        text: "System Questions Answered MinCount",
        subText: "System Questions Answered MinCount",
      },
      {
        text: "System Questions DocView MinCount",
        subText: "System Questions DocView",
      },
      {
        text: "System Trending KeyTerms Views MinCount",
        subText: "System Trending KeyTerms ViewsMinCount",
      },
      {
        text: "System User Logins MinCount",
        subText: "System User Logins MinCount",
      },
      {
        text: "System Docs Scraped MinCount",
        subText: "System Docs Scraped MinCount",
      },
      {
        text: "System Response Time",
        subText: "System Response Time",
      },
    ],
  },
};

export const homeTilesData = [
  {
    key: "0",
    title:'Agents',
    description:'Have the Vizerto Agent brief you on a subject matter of your choosing.',
    routing:'brief',
  },
  {
    key: "1",
    title:'Trending Questions',
    description:'View trending questions from your peer group.',
    routing:'trending',
  },
  {
    key: "2",
    title:'Open Questions',
    description:'View questions awaiting responses from experts.',
    routing:'open',
  },
  {
    key: "3",
    title:'My History',
    description:'View all previously searched and submitted questions.',
    routing:'history',
  },
  {
    key: "4",
    title:'Key Terms',
    description:'Navigate to frequent topics/terms searched by your peers.',
    routing:'keyterm',
  },
];

export const homeTilesData2 = [
  {
    key: "1",
    title:'Trending Questions',
    description:'View trending questions from your peer group.',
    routing:'trending',
  },
  {
    key: "2",
    title:'Open Questions',
    description:'View questions awaiting responses from experts.',
    routing:'open',
  },
  {
    key: "3",
    title:'My History',
    description:'View all previously searched and submitted questions.',
    routing:'history',
  },
  {
    key: "4",
    title:'Key Terms',
    description:'Navigate to frequent topics/terms searched by your peers.',
    routing:'keyterm',
  },
];

export const keyTermTypeOptions=[{
  label: 'One Word',
  value: '1',
},{
  label: 'Two Word',
  value: '2',
},{
  label: 'Three Word',
  value: '3',
}
]

export const ModalHeader = {
  styles:{
    color:'#2A364A',
    fontSize:'20px',
    fontFamily:'Helvetica'
  },
  questionText: {
    color:'rgb(42, 54, 74)',
    fontSize:'24px',
    fontFamily:'Inter'
  },
  answerText:{
    color:'rgb(92, 102, 123)',
    wordBreak: 'break-word',
  overflowWrap: 'break-word',
    fontWeight:300,
    fontSize:'15px',
    fontFamily:'Inter'
  }
}
